import React, { FC } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { UI_ModuleDocuments } from "../../../../../UI_ITO/indexUI";
import { TagSign } from "../TagSign/TagSign";
import { useParams } from "react-router-dom";
import { TagLeadSign } from "../TagSign/TagLeadSign";
import { applicationBankDocumentsApi } from "../../../../../services/documents/documents.api";
import { OPEN_SIGN_INFO_MODAL } from "../../../../../store/slices/applicationBankSlice/applicationBankSlice";
import { useAppDispatch } from "../../../../../store/reduxHooks";
import { getLeadSign } from "../../../../../utils/utilities/documents/getLeadSign";
import { getClientSign } from "../../../../../utils/utilities/documents/getClientSign";
import { DocumentWithFileArchive } from "../../../../../types/documents.type";
import { GetSignInfoQueryParams } from "../../../../../store/api/applicationBankApi/signing.api";

const isLeadSignRequired = (documentName: string) => {
  return ["Решение", "Договор"].includes(documentName);
};

const isClientSignRequired = (documentName: string) => {
  return "Решение" !== documentName;
};

interface ApplicationDetailsDoсSectionProps {
  documents: DocumentWithFileArchive[];
}

const { downloadDocument, downloadDocumentSignFile } =
  applicationBankDocumentsApi;

export const OfferDocListSection: FC<ApplicationDetailsDoсSectionProps> = ({
  documents,
}) => {
  const { applicationBankId } = useParams();

  const dispatch = useAppDispatch();

  const openSignInfoModal = (params: GetSignInfoQueryParams) => {
    dispatch(OPEN_SIGN_INFO_MODAL(params));
  };

  return (
    <div style={{ paddingBottom: "24px" }}>
      {Array.isArray(documents) &&
        documents?.map((doc) => {
          const document = doc?.document?.find((doc) => !doc.deleted_at);
          if (document) {
            const leadSignFile = getLeadSign(document);
            const clientSignFile = getClientSign(document);

            return (
              <div key={document.name + document.id}>
                <UI_ModuleDocuments
                  title={doc?.name}
                  titleDown={
                    document?.name ? (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (document && applicationBankId) {
                            downloadDocument({
                              applicationBankId: Number(applicationBankId),
                              fileId: document.id,
                              fileName: document.name,
                            });
                          }
                        }}
                      >
                        {document.name}
                      </span>
                    ) : (
                      "Документ не загружен"
                    )
                  }
                  icon={
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          gap: "10px",
                        }}
                      >
                        {isLeadSignRequired(doc.name) && (
                          <TagLeadSign
                            tag={leadSignFile ? "sign_true" : "sign_false"}
                            onClickDownload={() => {
                              if (
                                document &&
                                applicationBankId &&
                                leadSignFile
                              ) {
                                downloadDocumentSignFile({
                                  applicationBankId: Number(applicationBankId),
                                  fileId: document.id,
                                  signId: leadSignFile.id,
                                  fileName: leadSignFile.name,
                                });
                              }
                            }}
                            onClickSignInfo={() => {
                              leadSignFile &&
                                openSignInfoModal({
                                  applicationBankId: Number(applicationBankId),
                                  fileId: document?.id || 0,
                                  signId: leadSignFile.id,
                                });
                            }}
                          />
                        )}
                        {isClientSignRequired(doc.name) && (
                          <TagSign
                            tag={clientSignFile ? "sign_true" : "sign_false"}
                            onClickDownload={() => {
                              if (
                                document &&
                                applicationBankId &&
                                clientSignFile
                              ) {
                                downloadDocumentSignFile({
                                  applicationBankId: Number(applicationBankId),
                                  fileId: document.id,
                                  signId: clientSignFile.id,
                                  fileName: clientSignFile.name,
                                });
                              }
                            }}
                            onClickSignInfo={() => {
                              clientSignFile &&
                                openSignInfoModal({
                                  applicationBankId: Number(applicationBankId),
                                  fileId: document.id,
                                  signId: clientSignFile.id,
                                });
                            }}
                          />
                        )}
                      </div>

                      <DownloadOutlined
                        style={{ color: "black" }}
                        onClick={() => {
                          if (document && applicationBankId) {
                            downloadDocument({
                              applicationBankId: Number(applicationBankId),
                              fileId: document.id,
                              fileName: document.name,
                            });
                          }
                        }}
                      />
                    </>
                  }
                />
              </div>
            );
          }
        })}
    </div>
  );
};
